import {IconButton, Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

import {zIndexes} from '../../constants/index';

export const StyledHeader = styled(Box)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(2, 0, 2, 0),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const StyledHeaderWrapper = styled(Box)(() => ({
  width: '100%',
  display: 'block'
}));

export const StyledHeaderContainer = styled(Box)<{isReactNativeView?: boolean}>(({theme, isReactNativeView}) => ({
  padding: isReactNativeView ? theme.spacing(1.75, 2, 1.75, 2) : theme.spacing(0, 3, 3, 3),
  display: 'block'
}));

export const StyledBasketDrawerHeader = styled(Box)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(2, 0, 2, 0),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const StyledIconButton = styled(IconButton)(() => ({
  padding: 0
}));

export const StyledAlcoMessageWrapper = styled(Box)({
  display: 'flex',
  cursor: 'pointer'
});

export const StyledSectionHeader = styled(Box)<{isFlexibleBasketEnabled: boolean}>(({isFlexibleBasketEnabled}) => ({
  width: 'auto',
  display: 'flex',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  alignItems: 'flex-start',
  borderRadius: isFlexibleBasketEnabled ? ' 12px 12px 0px 0px' : '',
  '&.unavailable': {
    padding: `0px !important`
  },
  background: '#fff',
  '&.v2': {
    top: 0,
    position: isFlexibleBasketEnabled ? 'relative' : 'sticky',
    zIndex: zIndexes.basketDrawer,
    borderBottom: '1px solid #e8e8e8'
  }
}));

export const StyledHeaderContentWrap = styled(Box)(({theme}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

export const StyledUnavailableProducts = styled(Box)<{isFlexibleBasketEnabled?: boolean}>(
  ({theme, isFlexibleBasketEnabled}) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: isFlexibleBasketEnabled ? 'space-between' : 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
    textAlign: 'center',
    flex: 1,
    width: '100%',
    padding: theme.spacing(1, 0, 1, 0),
    backgroundColor: theme.palette.common.mds_global_color_red_15,
    borderRadius: isFlexibleBasketEnabled ? '12px 12px 0px 0px' : ''
  })
);

export const StyledUnavailableAlcoProductsLessThenAllowed = styled(StyledUnavailableProducts)({
  backgroundColor: '#FFEBE5'
});

export const StyledAvailableProducts = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
  textAlign: 'center',
  flex: 1,
  width: '100%',
  padding: theme.spacing(1, 0, 1, 0),
  backgroundColor: theme.palette.common.mds_global_color_green_20
}));

export const StyledDeliveryContainer = styled(Box)(({theme}) => {
  return {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    alignItems: 'center',
    padding: theme.spacing(2, 4, 2, 4),
    width: '100%'
  };
});

type StyledBasketSellerHeaderProps = {
  enableTopBorder?: boolean;
  isFlexibleBasketEnabled?: boolean;
  isReactNativeView?: boolean;
};

export const StyledBasketSellerHeader = styled(StyledDeliveryContainer)<StyledBasketSellerHeaderProps>(
  ({theme, enableTopBorder, isFlexibleBasketEnabled, isReactNativeView}) => ({
    flexDirection: 'column',
    gap: '4px',
    padding: isFlexibleBasketEnabled
      ? isReactNativeView
        ? theme.spacing(1)
        : theme.spacing(1, 2, 1, 2)
      : theme.spacing(1, 4, 1, 4),
    borderTop: enableTopBorder ? `1px solid ${theme.palette.grey[50]}` : undefined,
    width: '-webkit-fill-available'
  })
);

export const StyledBasketSellerName = styled(Box)(({theme}) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: '0.9rem'
}));

export const StyledBasketDeliveryInfo = styled(Box)<{withPrices?: boolean; isReactNativeView?: boolean}>(
  ({theme, withPrices, isReactNativeView}) => ({
    '& .info': {
      display: 'inline-block',
      color: 'crimson',
      fontSize: isReactNativeView ? '12px' : '0.8rem'
    },
    lineHeight: '18px',
    cursor: 'pointer',
    fontWeight: '400',
    fontSize: isReactNativeView ? '12px' : '0.8rem',
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    flex: 1,
    [theme.breakpoints.down(430)]: {
      minWidth: withPrices ? '120px' : '',
      width: withPrices ? 'min-content' : ''
    },
    [theme.breakpoints.down(350)]: {
      minWidth: withPrices ? '80px' : '',
      width: withPrices ? 'min-content' : ''
    }
  })
);

export const StyledBasketLabel = styled(Typography)(({theme}) => ({
  color: theme.palette.grey[400],
  fontSize: '0.8rem',
  textWrap: 'nowrap'
}));

export const StyledDeliveryFee = styled(Typography)(() => ({
  fontSize: '0.8rem',
  fontWeight: 400,
  textWrap: 'nowrap'
}));

export const PriceCrossed = styled(Typography)(({theme}) => ({
  textDecoration: 'line-through',
  fontSize: '0.8rem',
  color: theme.palette.grey[400],
  textWrap: 'nowrap'
}));

export const StyledShopLogo = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '2px solid #e8e8e8',
  borderRadius: '50%',
  overflow: 'hidden'
}));
